import React from 'react';
import { StyleSheet } from 'react-native';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

const DateSlash = () => {
  return (
    <TitleMdText key="slash" testID="slash" style={styles.slashInDate}>
      /
    </TitleMdText>
  );
};

const styles = StyleSheet.create({
  slashInDate: {
    justifyContent: 'flex-end',
    marginHorizontal: theme.spacing.s,
  },
});

export default DateSlash;
